import { render, staticRenderFns } from "./regionMapping.vue?vue&type=template&id=523b428b"
import script from "./regionMapping.vue?vue&type=script&lang=js"
export * from "./regionMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports